{
  "title": "Snare",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "1st-level abjuration",
  "level": 1,
  "castingTime": "1 minute",
  "range": "Touch",
  "components": "V, S, M (30 feet of cord or rope, which is consumed by the spell)",
  "duration": "Until dispelled or triggered",
  "description": [
    "While you cast this spell, you use the cord or rope to create a circle with a 5-foot radius on a flat surface within your reach. When you finish casting, the cord or rope disappears to become a magical trap.",
    "The trap is nearly invisible and requires a successful Intelligence (Investigation) check against your spell save DC to be found.",
    "The trap triggers when a Small creature or larger moves into the area protected by the spell. The triggering creature must succeed on a Dexterity saving throw or fall prone and be hoisted into the air until it hangs upside down 3 feet above the protected surface, where it is restrained.",
    "The restrained creature can make a Dexterity saving throw with disadvantage at the end of each of its turns and ends the restrained effect on a success. Alternatively, another creature that can reach the restrained creature can use an action to make an Intelligence (Arcana) check against your spell save DC. On a success, the restrained effect also ends."
  ],
  "spellLists": ["artificer", "druid", "eldritch-knight", "ranger", "wizard"]
}
